"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useSidebar } from "@/components/ui/sidebar";
import { getSaveAndExitHandler } from "@/components/editor-legacy/app-shared/utils/editor-unsaved-guard";
import { useEditorLeaveStore } from "@/utils/editor-unsaved-guard";
import { OctagonAlert } from "lucide-react";
import { useState } from "react";

export function EditorUnsavedChangesDialog() {
  const { setOpenMobile } = useSidebar();
  const open = useEditorLeaveStore((state) => state.open);
  const answerLeave = useEditorLeaveStore((state) => state.answerLeave);
  const [isSaving, setIsSaving] = useState(false);

  const handleExitWithoutSaving = () => {
    if (isSaving) return;
    setOpenMobile(false);
    answerLeave(true);
  };

  const handleSaveAndExit = async () => {
    const saveAndExit = getSaveAndExitHandler();
    if (!saveAndExit || isSaving) return;

    setIsSaving(true);
    try {
      const saved = await saveAndExit();
      if (!saved) return;

      setOpenMobile(false);
      answerLeave(true);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && !isSaving) answerLeave(false);
      }}
    >
      <DialogContent
        overlayClassName="z-[100] bg-black/40"
        className="top-12 z-[100] max-w-sm translate-y-0 p-4"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <DialogHeader className="items-center text-center sm:text-center">
          <OctagonAlert className="mx-auto size-8 text-red-600" />
          <DialogTitle>Unsaved changes</DialogTitle>
          <DialogDescription>
            Save your changes before leaving, or exit without saving.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="grid w-full grid-cols-2 gap-2 sm:space-x-0">
          <Button
            variant="outline"
            size="sm"
            onClick={handleExitWithoutSaving}
            disabled={isSaving}
          >
            Exit without saving
          </Button>
          <Button
            size="sm"
            onClick={() => void handleSaveAndExit()}
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Save and exit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
